var map = {
	"./ion-accordion_2.entry.js": [
		7512,
		8592,
		7512
	],
	"./ion-action-sheet.entry.js": [
		6470,
		8592,
		6470
	],
	"./ion-alert.entry.js": [
		5690,
		8592,
		5690
	],
	"./ion-app_8.entry.js": [
		8508,
		8592,
		8508
	],
	"./ion-avatar_3.entry.js": [
		3438,
		3438
	],
	"./ion-back-button.entry.js": [
		9119,
		8592,
		9119
	],
	"./ion-backdrop.entry.js": [
		2319,
		2319
	],
	"./ion-breadcrumb_2.entry.js": [
		4848,
		8592,
		4848
	],
	"./ion-button_2.entry.js": [
		4752,
		4752
	],
	"./ion-card_5.entry.js": [
		9870,
		8162
	],
	"./ion-checkbox.entry.js": [
		5892,
		8592,
		5892
	],
	"./ion-chip.entry.js": [
		9118,
		9118
	],
	"./ion-col_3.entry.js": [
		9538,
		9538
	],
	"./ion-datetime-button.entry.js": [
		4969,
		3707,
		4969
	],
	"./ion-datetime_3.entry.js": [
		1835,
		3707,
		8592,
		1835
	],
	"./ion-fab_3.entry.js": [
		6719,
		8592,
		6719
	],
	"./ion-img.entry.js": [
		3121,
		3121
	],
	"./ion-infinite-scroll_2.entry.js": [
		3025,
		8592,
		3025
	],
	"./ion-input.entry.js": [
		3914,
		8592,
		3914
	],
	"./ion-item-option_3.entry.js": [
		3761,
		8592,
		3761
	],
	"./ion-item_8.entry.js": [
		6138,
		8592,
		6138
	],
	"./ion-loading.entry.js": [
		2063,
		8592,
		2063
	],
	"./ion-menu_3.entry.js": [
		4950,
		8592,
		4950
	],
	"./ion-modal.entry.js": [
		9707,
		8592,
		9707
	],
	"./ion-nav_2.entry.js": [
		234,
		8592,
		234
	],
	"./ion-picker-column-internal.entry.js": [
		7209,
		8592,
		7209
	],
	"./ion-picker-internal.entry.js": [
		9448,
		3068
	],
	"./ion-popover.entry.js": [
		9215,
		8592,
		9215
	],
	"./ion-progress-bar.entry.js": [
		5635,
		5635
	],
	"./ion-radio_2.entry.js": [
		1497,
		8592,
		1497
	],
	"./ion-range.entry.js": [
		9964,
		8592,
		5922
	],
	"./ion-refresher_2.entry.js": [
		6199,
		8592,
		6199
	],
	"./ion-reorder_2.entry.js": [
		3549,
		8592,
		3549
	],
	"./ion-ripple-effect.entry.js": [
		5966,
		5966
	],
	"./ion-route_4.entry.js": [
		3187,
		3187
	],
	"./ion-searchbar.entry.js": [
		9092,
		8592,
		9092
	],
	"./ion-segment_2.entry.js": [
		7600,
		8592,
		7600
	],
	"./ion-select_3.entry.js": [
		1449,
		8592,
		9870
	],
	"./ion-spinner.entry.js": [
		1657,
		8592,
		1657
	],
	"./ion-split-pane.entry.js": [
		8394,
		8394
	],
	"./ion-tab-bar_2.entry.js": [
		4574,
		8592,
		4574
	],
	"./ion-tab_2.entry.js": [
		3514,
		3514
	],
	"./ion-text.entry.js": [
		7502,
		7502
	],
	"./ion-textarea.entry.js": [
		7832,
		8592,
		7832
	],
	"./ion-toast.entry.js": [
		9805,
		8592,
		9805
	],
	"./ion-toggle.entry.js": [
		7393,
		8592,
		7393
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 863;
module.exports = webpackAsyncContext;